'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EmailListRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailListRemote = exports.EmailListRemote = {
    fetchEmailLists: function fetchEmailLists(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>profile/lists' });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postSubscribeToEmailList: function postSubscribeToEmailList(_ref2) {
        var authToken = _ref2.authToken,
            code = _ref2.code,
            deployment = _ref2.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>profile/subscribe' });
            request.send({ code: code, source: 'web' });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postUnsubscribeFromEmailList: function postUnsubscribeFromEmailList(_ref3) {
        var authToken = _ref3.authToken,
            code = _ref3.code,
            deployment = _ref3.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>profile/unsubscribe' });
            request.send({ code: code, source: 'web' });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/emailList.js
// module id = Ukn/
// module chunks = 60